import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
type ReturnVoucherDataProps = {
  issuedVoucherCount: string;
  issuedVoucherTotalAmount: string;
  source: string;
};
export const IssuedReturnedVoucher: FunctionComponent<ReturnVoucherDataProps> = ({
  issuedVoucherCount,
  issuedVoucherTotalAmount,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>
                Issued Return Voucher
              </Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="center"
                  className={classes.headColor}
                  // style={{ width: "30%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Return Voucher
                </TableCell>

                <TableCell align="right" className={classes.headColor}>
                  {issuedVoucherCount ? issuedVoucherCount : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {issuedVoucherTotalAmount ? issuedVoucherTotalAmount : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headCell}
                  colSpan={2}
                >
                  Total
                </TableCell>

                <TableCell align="right" className={classes.headCell}>
                  {issuedVoucherTotalAmount ? issuedVoucherTotalAmount : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
